export default __webpack_public_path__ + "static/director-48034cd38031ac56aa92badf511182ba.jpg";